import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  minHeight?: number;
  width?: number;
}

export default function ModalContent({ title, minHeight, onClose, width, ...otherProps }: ModalHeaderProps): JSX.Element {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: width ?? 600,
        bgcolor: 'background.paper',
        borderRadius: 2,
        minHeight,
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: "#08B0A0",
          px: 4,
          height: '40px'
        }}
      >
        <Typography variant="h5" sx={{ color: 'white', fontWeight: '500', textTransform: 'uppercase' }}>
          {title}
        </Typography>
        <IconButton onClick={onClose} sx={{ padding: 0 }}>
          <CloseOutlinedIcon sx={{ color: 'white' }} />
        </IconButton>
      </Box>

      <Box
        sx={{
          maxHeight: 'calc(100vh - 150px)',
          overflowY: 'auto',
          p: 5,
          bgcolor: '#F5F5F5',
        }}
        {...otherProps}
      />
    </Box>
  );
}